module.exports = __webpack_public_path__ + "static/img/deve3.b50e837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve3.png
// module id = qJIL
// module chunks = 1